import React from 'react'
import ConnectedComponent from '../../../shared/connecter/ConnectedComponent'

export class LevelContainer extends React.Component {
  render(){
    return (<div className={'row ' + (this.props.className || '')}>
      <div className="col-md-4 col-sm-4 col-xs-4 score-title">
        <span>{this.props.name}</span>
        {this.props.bonus ? <span className="anotation">+ {this.props.bonus}</span> : null}
      </div>
      <div className="col-md-8 col-sm-8 col-xs-8" style={{padding:0}}>
        <div className="score-cell-wrapper">
          {this.props.children}
        </div>
      </div>
    </div>)
  }
}

export class ScoreContainer extends ConnectedComponent {
  constructor () {
    super()
    this.subscribe('players')
  }
  render () {
    const width = Math.round(100 / this.store.players.length) + '%'
    const played = this.props.level ?
        this.store.players.get(this.props.level.id) :
          null

    return (<div style={{width}} className={'score-cell ' + (played ? 'played ' : '') + (this.props.className || '')}>
      {this.props.children}
    </div>)
  }
}

export default LevelContainer


// WEBPACK FOOTER //
// ./src/game/level/containers/LevelContainer.jsx